import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
  selector: 'app-otp-field',
  standalone: true,
  imports: [NgOtpInputModule, CommonModule],
  templateUrl: './otp-field.component.html',
  styleUrl: './otp-field.component.scss'
})
export class OtpFieldComponent {
  otp: string = '';
  showOtpComponent = true;
  @Input() error: string = ''
  @Output() OTPReturnValue: EventEmitter<any> = new EventEmitter<string>();
  @ViewChild('ngOtpInput', { static: false}) ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      'width': window.innerWidth > 500 ? '50px' : '40px',
      'height': window.innerWidth > 500 ? '50px' : '40px',
      'margin': window.innerWidth > 500 ? '8px' : '4px'
    }
  };
 
  onOtpChange(otp: any) {
    this.otp = otp;
    this.OTPReturnValue.emit(this.otp);
  }

  setVal(val: any) {
    this.ngOtpInput.setValue(val);
  }

  toggleDisable(){
    if(this.ngOtpInput.otpForm){
      if(this.ngOtpInput.otpForm.disabled){
        this.ngOtpInput.otpForm.enable();
      }else{
        this.ngOtpInput.otpForm.disable();
      }
    }
  }

  onConfigChange() {
    this.showOtpComponent = false;
    this.otp = '';
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }
}
